import PropTypes from 'prop-types';
import React from 'react';

const AleloAddress = '/messages/address.png';

export const MessageQuestionAddress = (props) => {
  return (
    <>
      <div className="message-line" data-testid="message-received">
        <div
          className="message-receive"
          id={`msg-${props.message.id}`}
          data-aut-test="message-receive-text"
        >
          <div className="message-div">
            <span>{props.children} </span>
          </div>
        </div>
      </div>
      <div className="message-line" data-testid="message-address-icon">
        <div
          className="message-receive message-receive__no-background"
          id="msg-address-icon"
          data-aut-test="message-address-icon"
        >
          <div className="message-div">
            <img
              src={AleloAddress}
              alt="Desenho da frente de um restaurante, com uma pessoa na frente varrendo"
            />
          </div>
        </div>
      </div>
    </>
  );
};

MessageQuestionAddress.propTypes = {
  children: PropTypes.string,
  message: PropTypes.object
};
